import axios from 'axios';

import { SEATERS_API_BASE_URL } from '@seaters/constants';

// scanner devices authenticate with x-scan-session-token only. Kept off the shared
// instance so a logged-in user's bearer token never rides along and a device 401
// never hits the expired-login redirect.
export const deviceApi = axios.create({ baseURL: SEATERS_API_BASE_URL });

deviceApi.interceptors.response.use((response) => response.data);
